module.exports = __webpack_public_path__ + "files/079812bf5f486eb873cf36187513d32d.png";